
import React from 'react'
import {Panel, FormControl, Button} from 'react-bootstrap';
import {injectIntl, intlShape, FormattedRelative} from 'react-intl';
import { Link } from 'react-router';

class SearchBox extends React.Component {
    render(){
        const {intl} = this.props;
        const t = (message, data = {}) => {
            if(!message) return '';
            return intl.formatMessage({id : message}, data);
        };
        return <Panel header={t('BROWSE')} className="brand-panel">
              <div>               
                <strong> <Link to="/browse-ideas/1">{t('Browse Initiatives')}</Link></strong>
                <p className="p-small-padding">{t('You can browse existing Initiatives')}.</p>           
              </div>
              <div>
                <strong><Link to="/browse-ideas/2">{t('Browse CI-Proposals')}</Link></strong>
                <p className="p-small-padding">{t('You can browse existing CI-Proposals')}.</p>  
              </div>
              <div>
                <strong><a href="http://focus.wartsila.com/#/Home">{t('Browse old Initiatives and CI-Proposals')}</a></strong>
              </div>
        </Panel>;
    }
};


export default injectIntl(SearchBox);


// WEBPACK FOOTER //
// ./components/Home/SearchBox.js